import * as React from 'react';

export interface AmountProps {
  amount: number | string;
  currency?: string;
}

export default function Amount(props: AmountProps) {
  if (props.amount === undefined || props.amount === null) {
    return <></>;
  }
  const amount: number = Number(props.amount);
  const { currency = '$' } = props;

  return amount < 0 ? (
    <>
      -&nbsp;{currency}
      {(amount * -1).toFixed(2)}
    </>
  ) : (
    <>
      {currency}
      {amount.toFixed(2)}
    </>
  );
}
